module.exports = __webpack_public_path__ + "img/img_series_107.e7a774e9.png";